import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { watch, computed } from 'vue'
import { useRefiner } from '@crv/vue-3-components'
import { i18n } from '@/i18n/entry'
import { useDisplay } from 'vuetify'
import router from '@/router'
import packageJson from '@/../package.json'

  
export default /*@__PURE__*/_defineComponent({
  __name: 'RefinerButton',
  setup(__props) {

const { smAndUp } = useDisplay()

  
  const { setLocale, showRefinerForm } = useRefiner({
    projectId: process.env.VUE_APP_REFINER_GENERAL_PROJECT_ID,
    locale:  i18n.global.locale
  })
  
  watch(() => i18n.global.locale, (newLocale) => {
    setLocale(newLocale)
  })
    
  const onClickFeedback = () => {
    showRefinerForm({
      formId: process.env.VUE_APP_REFINER_GENERAL_FORM_ID,
      appVersion: packageJson.version,
      route: router.currentRoute.value.fullPath,
      isMobile: (!smAndUp.value).toString(),
    })
  }

  const refinerClass = computed(() => smAndUp.value ? 'desktop' : 'mobile')

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(_component_v_btn, {
    class: _normalizeClass(["refiner_button", refinerClass.value]),
    color: "primary",
    onClick: onClickFeedback
  }, {
    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
      _createTextVNode(" Feedback ", -1)
    ]))]),
    _: 1
  }, 8, ["class"]))
}
}

})